import {initializeDoughnutChart, initializeStackedBarsChart} from './charts'

$(function () {

    if ( $('#annualreport2020').length > 0 ) {


        /* Expand letter */
        $('.js-expand-letter').on('click', function(e){
            e.stopPropagation();
            $('.js-letter').addClass('expanded');
        });

        $('.js-close-letter').on('click', function(e){
            e.stopPropagation();
            
            document.getElementById("letter").scrollIntoView()
            $('.js-letter').removeClass('expanded');

        });

    };

    /* Toggle meta boxes */
    let metaBtn = document.querySelectorAll('.js-meta-btn');
    let metaContent = document.querySelectorAll('.js-meta-content');

    $('body').on('click', '.js-meta-btn', function (e) {

        e.preventDefault();
        e.stopPropagation();

        let btn = this;
        let currentMeta = btn.dataset.meta;
        let currentMetaGroup = btn.dataset.metagroup;
        let activeClass = btn.dataset.activeclass;

        activeClass = activeClass ? activeClass : 'active-dark';

        metaBtn.forEach(btn => {
            if ( btn.dataset.metagroup == currentMetaGroup ) {
                btn.classList.remove(activeClass);
            }
        })

        btn.classList.add(activeClass);

        metaContent.forEach(content => {

            if ( content.dataset.metagroup == currentMetaGroup ) {
                content.classList.remove('visible');
            }

            if ( content.dataset.metagroup == currentMetaGroup && content.dataset.metaid == currentMeta ) {
                content.classList.add('visible');

                // Check if meta content contains a doughnut/pie chart
                const doughnutCharts = Array.from(content.querySelectorAll('.doughnut-chart-canvas'))
                doughnutCharts.forEach(chart => initializeDoughnutChart(chart))

                const stackedBarsCharts = Array.from(content.querySelectorAll('.stacked-bars-chart-canvas'))
                stackedBarsCharts.forEach(chart => initializeStackedBarsChart(chart))
            }

        })
    });

});